<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>ऑनबोर्डिंग प्रक्रिया  </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/jitZ29MM6P0?si=5VFW-WvVm6ZI6KE_"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <label for="" class="mt-4">सामान्य व्यावसायिक संदर्भ में ऑनबोर्डिंग प्रक्रिया, ग्राहकों, या उपयोगकर्ताओं को किसी उत्पाद, या सेवा में एकीकृत और उन्मुख करने में शामिल चरणों और गतिविधियों को संदर्भित करती है। यह एक महत्वपूर्ण चरण है जो इसमें शामिल व्यक्तियों के लिए सकारात्मक और सफल अनुभव की नींव रखता है।  </label>
                </div>

                <div class="col-md-12" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')" id="2">
                    <h2 class="mt-4">पे जी की ऑनबोर्डिंग प्रक्रिया  </h2>
                    <label for=""> यहां पे जी की ऑनबोर्डिंग प्रक्रिया की सामान्य रूपरेखा दी गई है:  </label>


                    <h4 class="mt-4"><b>चरण 1: पंजीकरण: </b></h4>
                    <label for="">व्यापारियों को पेशेवर, व्यावसायिक या सरकारी इकाई जैसे खाते का प्रकार चुनना होगा। फिर अगले चरण में, पे जी खाता प्रकार के अनुसार विवरण भरने के लिए कहता है।  </label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-1.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4">व्यापारियों को अपना पैन या जीएसटी विवरण भरना होगा। </label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-2.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4">यदि व्यापारी के पास जीएसटी नंबर है तो वह जीएसटी का चयन कर सकता है और विवरण भर सकता है। </label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-3.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4">व्यवसाय स्वामी का विवरण जोड़ें </label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-4.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-4">
                        व्यापारियों को अपने व्यवसाय का संक्षिप्त विवरण जोड़ना होगा। 
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-5.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-6.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <div class="row mt-4">
                        <h4><b>चरण 2: भुगतान उद्देश्य: </b></h4>
                        <label for="" class="mt-4">
                            पे जी भुगतान सेवाओं का उपयोग व्यापारियों द्वारा निर्दिष्ट किया जाना चाहिए। उदाहरण के लिए, खुदरा विक्रेता की वेबसाइट पर चालान बनाना, शुल्क जमा करना आदि।  </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onbo1.png" width="100%" height="100%" alt="">
                            </div>
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onbo2.png" width="100%" height="100%" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <h4><b>चरण 3: बैंक विवरण: </b></h4>
                        <label for="" class="mt-4">
                            खाताधारक का नाम, खाता संख्या और आईएफएससी कोड जैसे बैंक विवरण व्यापारियों द्वारा भरे जाएंगे।  </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/o-8.png" width="100%" height="100%" alt="">
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <h4><b>चरण 4: व्यवसाय अवलोकन: </b></h4>
                        <label for="" class="mt-4">
                            पे जी आम तौर पर व्यापारी के व्यवसाय की प्रकृति और दायरे को समझने के लिए व्यवसाय अवलोकन मांगता है। यह जानकारी भुगतान गेटवे कंपनी को उनकी सेवाओं के लिए व्यापारी की उपयुक्तता का आकलन करने, संभावित जोखिमों की पहचान करने और नियामक आवश्यकताओं का अनुपालन करने में मदद करती है।   </label>
                        <div class="row ">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/o-11.png" width="100%" height="100%" alt="">
                            </div>
                            <div class="col-md-12 mt-3">
                                <img src="./assets/o-10.png" width="100%" height="100%" alt="">
                            </div>
                            <div class="col-md-12 mt-3">
                                <img src="./assets/o-12.png" width="100%" height="100%" alt="">
                            </div>
                            <div class="col-md-12 mt-3">
                                <img src="./assets/o-13.png" width="100%" height="100%" alt="">
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4" >
                        <h4 ><b>चरण 5: दस्तावेज़ सत्यापन: </b></h4>
                        <label for="" class="mt-4">
                            व्यापारी को सत्यापन के लिए आवश्यक कानूनी और नियामक दस्तावेज जमा करने की आवश्यकता होती है, जिसमें व्यवसाय पंजीकरण प्रमाणपत्र, पैन कार्ड, आधार कार्ड, सरकारी आईडी आदि शामिल हो सकते हैं। पे जी की टीम प्रामाणिकता और वैधता सुनिश्चित करने के लिए प्रस्तुत दस्तावेजों की समीक्षा और सत्यापन करती है। व्यापार। </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/o-9.png" width="100%" height="100%" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4" >
                        <h4 ><b>चरण 6: अनुबंध ई-हस्ताक्षर: </b></h4>
                        <label for="" class="mt-4">
                            सफल परीक्षण और अनुपालन जांच के बाद, पे जी और व्यापारी के बीच एक समझौते ई-साइन पर हस्ताक्षर किए जाएंगे।  </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/o-14.png" width="100%" height="100%" alt="">
                            </div>
                            <div class="col-md-12 mt-3">
                                <img src="./assets/o-15.png" width="100%" height="100%" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची :
                    </h5>
                </div>
               
                <div class="col-md-12">
                    <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'color':colors=='1'}"
                                    (click)="color('1')">
                                    ऑनबोर्डिंग प्रक्रिया क्या है? </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">पे जी की ऑनबोर्डिंग प्रक्रिया 
                                </span>
                            </div>
                        </div>
                    </a>
                </div>

              


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/pay-out']"> <button class="btn btn-color" > <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;पे आउट 
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/features']"> <button class="btn btn-color"
                        (click)="menues('Web Integraation')">पे जी फीचर्स 
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div>
        </div>
    </div>
</div>